// @flow
import React, { Component } from 'react'
import { Grid, Row, Col } from 'react-flexbox-grid'

import './styles.css'
import { post } from '../../services/utils'
import { Link } from 'react-router-dom'
import ReferralForm from './components/form'

export default class WinkReferral extends Component {
  constructor(props) {
    super(props)
    this.state = {
      email: '',
      name: '',
      numberOfRefferals: 3,
      referrals: []
    }

    this.handleChange = this.handleChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  componentDidMount() {
    const { username, name } = this.props.match.params
    const { numberOfRefferals } = this.state
    const referrals = Array.apply(null, Array(numberOfRefferals))
      .map(() => ({ name: '', email: '' }))
    this.setState({
      email: username,
      name,
      referrals
    })
  }

  /**
   * If all inputs have data even though it is wrong, let's add more input
   * @param referrals
   */
  mustAddMoreInputs({ referrals }) {
    const filledInputs = referrals.reduce((cont, referral) => {
      if (referral.email && referral.name) {
        return cont + 1
      }
    }, 0)

    return filledInputs === referrals.length
  }

  componentDidUpdate(prevProps, prevState) {
    const { referrals } = this.state
    // If the last input is filled, then add a new one.
    const addMoreInputs = this.mustAddMoreInputs({ referrals })

    if (referrals.length <= 10 && addMoreInputs) {
      referrals.push({ name: '', email: '' })

      this.setState({
        referrals
      })
    }
  }

  render() {
    const { name, referrals } = this.state
    return (
      <Grid fluid>
        <Row center='xs'>
          <Col className='main-container' xs={12} sm={12} md={12} lg={9}>
            <Row center='xs'>
              <Col className='wink-top-logo' />
            </Row>
            <Row center='xs'>
              <Col className='tittle'>
                Referí y ganá con Wink, {name}
              </Col>
            </Row>
            <Row center='xs'>
              <Col className='message' xs={12} sm={8} md={8} lg={8} >
                Invitá a tus compas y familiares a que descarguen y completen el proceso de registro
                en Wink y nosotros te premiamos.
              </Col>
            </Row>
            <ReferralForm
              onChange={this.handleChange}
              onSubmit={this.handleSubmit}
              referrals={referrals}
            />
            <Row center='xs'>
              <Col className='warning-message' xs={12} sm={10} md={10} lg={10}>
                Ver reglamento en <a href="www.holawink.com">www.holawink.com</a>
              </Col>
            </Row>
          </Col>
        </Row>
      </Grid>
    )
  }

  handleChange(event, i, type) {
    const value = event.target.value
    this.setState(prevState => {
      prevState.referrals[i][type] = value
      return {
        referrals: prevState.referrals
      }
    })
  }

  handleCleanReferrals(referrals) {
    const numberOfRefferals = referrals.filter(item => (
      item.name || item.email
    )).length

    if (!numberOfRefferals) {
      return false
    }

    const cleanReferrals = referrals.filter(item => (
      item.name !== '' && /^[a-zA-Z\s]*$/.test(item.name) &&
      item.name !== '' && /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(item.email)
    ))

    if (cleanReferrals.length !== numberOfRefferals) {
      return false
    }

    return cleanReferrals
  }

  async handleSendInvites(name, email, referrals) {
    try {
      const url = `${process.env.REACT_APP_API_REST_BASE}/referrals/add`
      await post(url, {
        email,
        referrals
      })
      this.props.history.push('/referral/success', {
        name,
        email,
        numberOfRefferals: referrals.length
      })
    } catch (err) {
      alert(`Hubo un error ${err}`)
    }
  }

  async handleSubmit(event) {
    event.preventDefault()
    const {
      name,
      email,
      referrals
    } = this.state
    const cleanReferrals = this.handleCleanReferrals(referrals)
    if (!cleanReferrals) {
      return
    }

    await this.handleSendInvites(name, email, cleanReferrals)
  }
}



// WEBPACK FOOTER //
// ./src/pages/Referral/index.js